"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/useArchiveCampaign.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _broadcast = require('shared/selectors/broadcast');
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');

var _ArchiveCampaignModal = require('./ArchiveCampaignModal'); var _ArchiveCampaignModal2 = _interopRequireDefault(_ArchiveCampaignModal);
var _campaignState = require('./campaignState');
var _leaveGuard = require('./leaveGuard');
var _addingRecipients = require('./addingRecipients');

/* Archive and Unarchive for a campaign row or page (Rev 20). An unfinished
 * draft archives at once; a finished campaign asks first (J3). Archiving the
 * campaign on screen, from its page or its sidebar row, first asks before
 * its unsaved work is left behind (R800-1). Nothing changes until the server
 * agrees, so a refused archive keeps that work; then, if the campaign is
 * still the one on screen, the selection moves to the campaign list, since
 * it has just left the list it was selected in (J1, R800-8). */
const useArchiveCampaign = (campaignKey) => {
  const campaignName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _ => _.Name]), () => ( '')))
  const isDraft = _hooks.useAppSelector.call(void 0, state => {
    const campaign = _broadcast.selectCampaignByKey.call(void 0, state, campaignKey)
    return !!campaign && _campaignState.isUnfinishedCampaign.call(void 0, campaign)
  })
  const guards = _leaveGuard.useLeaveGuards.call(void 0, )
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [isConfirming, setIsConfirming] = _react.useState.call(void 0, false)
  // P2': the server refuses an archive while a background Add runs.
  const archiveBlockedReason = _addingRecipients.useIsAddingRecipients.call(void 0, campaignKey) ? _addingRecipients.WAIT_FOR_ADD_REASON : null

  const archive = _react.useCallback.call(void 0, 
    () => {
      setIsConfirming(false)
      const go = () => _actions2.default.archiveCampaign(campaignKey).then(
        () => { if (_leaveGuard.isCampaignOnScreen.call(void 0, campaignKey)) _actions2.default.gotoCampaigns() },
        () => showWarningBar(`Failed to archive ${campaignName}`),
      )
      const guard = _leaveGuard.isCampaignOnScreen.call(void 0, campaignKey) ? guards.get(campaignKey) : undefined
      if (guard) guard(go)
      else go()
    },
    [campaignKey, campaignName, guards, showWarningBar],
  )
  const onArchive = _react.useCallback.call(void 0, 
    () => {
      if (archiveBlockedReason) return
      if (isDraft) archive()
      else setIsConfirming(true)
    },
    [isDraft, archive, archiveBlockedReason],
  )
  const onUnarchive = _react.useCallback.call(void 0, 
    () => {
      _actions2.default.unarchiveCampaign(campaignKey)
        .catch(() => showWarningBar(`Failed to unarchive ${campaignName}`))
    },
    [campaignKey, campaignName, showWarningBar],
  )
  const onCancel = _react.useCallback.call(void 0, () => setIsConfirming(false), [])

  const confirmModal = (
    _react2.default.createElement(_ArchiveCampaignModal2.default, {
      isOpen: isConfirming,
      campaignName: campaignName,
      onClose: onCancel,
      onConfirm: archive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
    )
  )

  return { onArchive, onUnarchive, confirmModal, archiveBlockedReason }
}

exports. default = useArchiveCampaign
